<template>
  <div class="lineteam">
    <div class="left_box">
      <div class="baseInfo">
        <div class="cross">
          <div class="line"></div>
          <div class="info">基本信息</div>
        </div>
        <el-form label-width="146px">
          <el-form-item label="订单编号：">{{orderDetails.id}}</el-form-item>
          <el-form-item label="订单状态：">
            <p v-html="status"></p>
          </el-form-item>
          <el-form-item label="订单时间：">{{orderDetails.createDate}}</el-form-item>
        </el-form>
      </div>

      <div class="baseInfo">
        <div class="cross">
          <div class="line"></div>
          <div class="info">支付信息</div>
        </div>
        <el-form label-width="146px">
          <el-form-item label="支付渠道：">{{orderDetails.payType=='1'?'微信支付':'其他'}}</el-form-item>
          <el-form-item v-if="zhifu" label="支付金额：">
            <span style="color:rgba(251,120,120,1);">￥{{orderDetails.payAmount}}</span>
          </el-form-item>
          <el-form-item v-if="daizhifu" label="待支付金额：">
            <span style="color:rgba(251,120,120,1);">￥{{orderDetails.payAmount}}</span>
          </el-form-item>
          <el-form-item v-if="liushuihao" label="支付流水号：">{{orderDetails.transactionId}}</el-form-item>

          <el-form-item v-if="shengyushijian" label="订单支付所剩时间：">
            <span style="color:rgba(0,138,255,1);">{{this.shijian}}</span>
          </el-form-item>
        </el-form>
      </div>

      <div class="baseInfo">
        <div class="cross">
          <div class="line"></div>
          <div class="info">物流信息</div>
        </div>
        <el-form label-width="146px">
          <el-form-item label="收货人：">{{orderDetails.address && orderDetails.address.name}}</el-form-item>
          <el-form-item label="联系电话：">{{orderDetails.address && orderDetails.address.phone}}</el-form-item>
          <el-form-item label="收获地址：">{{orderDetails.address && orderDetails.address.address}}</el-form-item>
          <el-form-item v-if="wuliu" label="物流公司：">{{orderDetails.logistics && orderDetails.logistics.company}}
          </el-form-item>
          <el-form-item v-if="wuliu" label="物流单号：">{{orderDetails.logistics && orderDetails.logistics.order}}
          </el-form-item>
        </el-form>
      </div>

      <div class="baseInfo" v-if="beizhu1">
        <div class="cross">
          <div class="line"></div>
          <div class="info">备注</div>
        </div>
        <el-form label-width="146px">
          <el-form-item label="取消原因：">{{orderDetails.cancelReason}}</el-form-item>
          <el-form-item label="取消时间：">{{orderDetails.cancelTime}}</el-form-item>
        </el-form>
      </div>
      <div class="baseInfo" v-if="beizhu2">
        <div class="cross">
          <div class="line"></div>
          <div class="info">备注</div>
        </div>
        <el-form label-width="146px">
          <el-form-item label="完成类型">{{orderDetails.doneType=='1'?'客户触发':'七天自动收获'}}</el-form-item>
        </el-form>
      </div>
    </div>
    <div class="right_box">
      <div class="baseInfo">
        <div class="cross">
          <div class="line"></div>
          <div class="info">销售信息</div>
        </div>
        <el-form label-width="146px">
          <el-form-item
            label="销售人员："
          >{{orderDetails.entMidData && orderDetails.entMidData.realName}}
          </el-form-item>
          <el-form-item label="组织架构：">{{orderDetails.orgName}}</el-form-item>
          <el-form-item label="销售电话：">{{orderDetails.entMidData && orderDetails.entMidData.phone}}</el-form-item>
          <el-form-item
            label="销售微信："
          >{{orderDetails.entMidData && orderDetails.entMidData.wxNumber}}
          </el-form-item>
        </el-form>
      </div>

      <div class="baseInfo">
        <div class="cross">
          <div class="line"></div>
          <div class="info">商品信息</div>
        </div>
        <el-form label-width="146px">
          <el-form-item label="商品名称：">{{orderDetails.itemJson.name}}</el-form-item>
          <el-form-item
            label="商品数量："
          >{{orderDetails.itemJson && orderDetails.itemJson.onSale}}{{orderDetails.itemJson &&
            orderDetails.itemJson.mmUnitName}}
          </el-form-item>
          <el-form-item label="商品价格：">￥{{orderDetails.itemJson && orderDetails.itemJson.custRetail}}</el-form-item>
        </el-form>
      </div>
    </div>

    <changIndet ref="changIndet" :id="orderDetails.id" @action="actionClick"></changIndet>
    <quxiaodingdan ref="quxiaodingdan" :id="orderDetails.id" @action="actionClick"></quxiaodingdan>

    <div class="btn_box">
      <el-button
        @click="btnClick"
        v-if="showChangeStatus"
        type="primary"
        :class="{active:active}"
      >
        <span>{{active?'取消订单':'更改状态'}}</span>
      </el-button>
      <el-button plain @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
  import changIndet from "./changeIndet";
  import quxiaodingdan from "./quxiaodingdan";
  import GlobalUtil from "../../../utils/globalUtil";

  export default {
    components: {
      quxiaodingdan,
      changIndet,
    },
    data() {
      return {
        showChangeStatus: true, // 是否显示更改状态按钮,
        zhifu: true, // 是否显示支付
        daizhifu: true, // 是否显示待支付
        liushuihao: true, // 是否显示流水单号
        shengyushijian: true, // 是否显示剩余支付时间
        beizhu1: false, // 是否显示备注
        beizhu2: false, // 是否显示备注
        active: false, // 更改状态按钮的颜色和文字,
        status: null, // 订单状态文字
        orderDetails: {}, // 订单详情,
        orderStatus: null,
        id: null,
        shijian: null,
        createDate: '',
        timeId: null,
        wuliu: false
      };
    },
    created() {
      // console.log(this.$route.params.orderStatus);
      // console.log(this.$route.params.id);
      this.id = GlobalUtil.getSessionStorage("rowData").id;
      // 获取订单详情接口
      this.getInfo();
    },
    methods: {
      // 获取订单详情
      getInfo() {
        this.$axios.get(this.$url.getInfo, {id: this.id}).then(res => {
          console.log("我是订单详情", res);
          this.orderStatus = res.data.orderStatus
          this.changeStatus();
          res.data.itemJson = typeof res.data.itemJson == "string" ? JSON.parse(res.data.itemJson) : "";
          res.data.address = typeof res.data.address == "string" ? JSON.parse(res.data.address) : "";
          if (res.data.logistics) {
            res.data.logistics = typeof res.data.logistics == "string" ? JSON.parse(res.data.logistics) : "";
          }
          this.orderDetails = res.data;
          this.createDate = res.data.createDate
          console.log(this.orderDetails);
          let that = this;
          if (this.shengyushijian) {
            that.jisuanshijian()
            this.timeId = setInterval(function () {
              that.jisuanshijian()
            }, 1000)
          }
        });
      },
      jisuanshijian() {
        let jiange = 2 * 60 * 60 * 1000 - (new Date() - new Date(this.createDate).getTime());
        if (jiange > 0) {
          this.shijian = GlobalUtil.formatDuring(jiange)
        } else {
          this.timeId = null
        }
      },
      actionClick(type) {
        console.log(type);
        this.getInfo()
      },
      btnClick() {
        if (this.active) {
          this.$refs.quxiaodingdan.dialogTableVisible = true
        } else {
          this.$refs.changIndet.dialogTableVisible = true
        }
      },
      changeStatus() {
        if (this.orderStatus == "11") {
          this.status1();
        } else if (this.orderStatus == "10") {
          this.status2();
        } else if (this.orderStatus == "13") {
          this.status3();
        } else if (this.orderStatus == "12") {
          this.status4();
        } else if (this.orderStatus == "14") {
          this.status5();
        }
      },
      // 待发货
      status1() {
        this.status = '<span style="color:#008AFF">待发货</span>';
        this.showChangeStatus = true;
        this.daizhifu = false;
        this.shengyushijian = false;
      },
      // 待付款
      status2() {
        this.status = '<span style="color:#FB7878">待付款</span>';
        this.showChangeStatus = false;
        this.zhifu = false;
        this.liushuihao = false;
      },
      // 已取消
      status3() {
        this.status = "<span>已取消</span>";
        this.showChangeStatus = false;
        this.zhifu = false;
        this.liushuihao = false;
        this.shengyushijian = false;
        this.beizhu1 = true;
      },
      // 已发货
      status4() {
        this.status = '<span style="color:#00BDC3">已发货</span>';
        this.showChangeStatus = true;
        this.daizhifu = false;
        this.shengyushijian = false;
        this.active = true;
        this.wuliu = true;
      },
      // 已完成
      status5() {
        this.status = '<span style="color:#04A155">已完成</span>';
        this.daizhifu = false;
        this.shengyushijian = false;
        this.showChangeStatus = false;
        this.beizhu2 = true;
        this.wuliu = true;
      }
    }
  };
</script>

<style lang='less' scoped>
  .lineteam {
    height: 100%;
    width: 100%;
    position: relative;
    background-color: #fff;
    display: flex;
    padding: 30px;
    box-sizing: border-box;

    .left_box {
      width: 50%;
      height: 100%;
    }

    .right_box {
      width: 50%;
      height: 100%;
    }

    .baseInfo {
      height: 160px;
      width: 100%;
      margin-bottom: 40px;

      .cross {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        margin-bottom: 10px;

        .line {
          width: 3px;
          height: 19px;
          background: rgba(102, 102, 102, 1);
          margin-right: 5px;
        }

        .info {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }

    ::v-deep .el-form-item {
      ::v-deep .el-form-item__label,
      ::v-deep .el-form-item__content {
        height: 18px !important;
        line-height: 18px;
      }

      margin-bottom: 16px !important;
      height: 18px !important;
    }

    .btn_box {
      position: absolute;
      bottom: 30px;
      left: 50px;
      display: flex;
    }

    .active {
      background: #fb7878 !important;
      border: 1px solid #fb7878;
    }
  }
</style>
